export const learningHubUrls = {
  slack:
    'https://kb.flair.hr/docs/learn/absence-management/slack-absence-requests',
};
